import "bootstrap/dist/css/bootstrap.min.css";
import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import '../../styles/noticia1.css';
import bannerBlog from '../../img/bannerBlog.png';
import Footer from "../../components/Footer/Footer";
import logoBranca from '../../img/logoBranca.png';
import Manchete from "../../components/Manchete/Manchete";
import { Link } from 'react-router-dom';


function noticia() {
  return (
        <div>
            <Navbar expand="lg" className="bg-body-tertiary" id="navbar">
            <Container fluid>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Navbar.Brand to="/" id="brand">
                    <a href="/">
                        <img src={logoBranca} style={{width:'auto', marginLeft:'15px'}}/>
                    </a>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Collapse id="navbarScroll">
                    <Nav
                        className="me-auto my-2 my-lg-0"
                        style={{ maxHeight: '100px' }}
                        navbarScroll >
                        <Link to="/institucional" style={{color: '#fff', marginLeft:'60px', fontWeight:'400', textDecoration: 'none'}}>Institucional</Link>
                        <Link to="/" style={{color: '#fff', marginLeft:'60px', fontWeight:'400', textDecoration: 'none'}}>Atuação</Link>
                        <Link to="/blog" style={{color: '#fff', marginLeft:'60px', fontWeight:'400', textDecoration: 'none'}}>Blog e notícias</Link>
                        <Link to="/formulario" style={{color: '#fff', marginLeft:'60px', fontWeight:'400', textDecoration: 'none'}}>Incentivos fiscais</Link>
                        <Link to="/" style={{color: '#fff', marginLeft:'60px', fontWeight:'400', textDecoration: 'none'}}>Contato</Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
            </Navbar>
            <div className="parteBranca" style={{alignItems: 'center'}}>
                <Manchete />
        
                
            </div>
            <br /><br /><br /><br /><br />
            <Footer />
        </div>
  );
}

export default noticia;